import React from 'react';
import {Link} from "react-router-dom";

import {
        _printNumber, 
        } from '../helpers/helpers'

interface VersionWebsitesRefProps {
	technologyURL: string;
	version: string;
	domainCount: number;
}

export default function VersionWebsitesRef({technologyURL, version, domainCount}: VersionWebsitesRefProps) {

    return (
            <Link  
                className="link-hover"
                to={`/technology/${technologyURL}/version/${version}/websites`}
            >
                {_printNumber(domainCount)}
            </Link>
        )
}